/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { SolutionStatusOnlyDtoModel, SolutionStatusOnlyDtoModelType } from "./SolutionStatusOnlyDtoModel"
import { SolutionStatusOnlyDtoModelSelector } from "./SolutionStatusOnlyDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  pendingSolution: SolutionStatusOnlyDtoModelType;
}

/**
 * ProjectRouteStopMovingDtoBase
 * auto generated base class for the model ProjectRouteStopMovingDtoModel.
 *
 * Stop moving
 */
export const ProjectRouteStopMovingDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ProjectRouteStopMovingDto')
  .props({
    __typename: types.optional(types.literal("ProjectRouteStopMovingDto"), "ProjectRouteStopMovingDto"),
    pendingSolution: types.union(types.undefined, MSTGQLRef(types.late((): any => SolutionStatusOnlyDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ProjectRouteStopMovingDtoModelSelector extends QueryBuilder {
  pendingSolution(builder: string | SolutionStatusOnlyDtoModelSelector | ((selector: SolutionStatusOnlyDtoModelSelector) => SolutionStatusOnlyDtoModelSelector) | undefined) { return this.__child(`pendingSolution`, SolutionStatusOnlyDtoModelSelector, builder) }
}
export function selectFromProjectRouteStopMovingDto() {
  return new ProjectRouteStopMovingDtoModelSelector()
}

export const projectRouteStopMovingDtoModelPrimitives = selectFromProjectRouteStopMovingDto()
